import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App/index";
import reportWebVitals from "./reportWebVitals";

// Handle chunk load errors (occurs after new deployments when old chunks are requested)
window.addEventListener('error', (event) => {
  if (event.message && event.message.includes('ChunkLoadError')) {
    // Clear cache and reload to get the latest version
    if ('caches' in window) {
      caches.keys().then((names) => {
        names.forEach((name) => caches.delete(name));
      });
    }
    // Reload the page to fetch new chunks
    window.location.reload();
  }
});

// Also handle unhandled promise rejections for dynamic imports
window.addEventListener('unhandledrejection', (event) => {
  if (event.reason && event.reason.name === 'ChunkLoadError') {
    event.preventDefault();
    // Prevent infinite reload loop
    const lastReload = sessionStorage.getItem('chunk_reload_time');
    const now = Date.now();
    if (!lastReload || now - parseInt(lastReload) > 10000) {
      sessionStorage.setItem('chunk_reload_time', now.toString());
      window.location.reload();
    }
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
